
import {  defineComponent,reactive, toRefs, onMounted, nextTick } from 'vue'
import { upAnalysis } from '@/api/index'
import ExpandableText from '@/components/ExpandableText.vue'
import { useRoute } from 'vue-router'
import ws from '../websocket/index'
import stock from '@/utils/stock'
export default defineComponent({
  components: { ExpandableText },
  setup(props: any, context: any) {
    const route = useRoute()
    const { market , symbol, theme, time, token } = route.query
    let newTime :number = 0
    newTime = ( Number(time) * 1000)
    console.log('打印时间===',newTime)
    const type1 = {
        1: '极弱',
        2: '弱',
        3: '强',
        4: '极强'
    }
    const type2 = {
        1: '大',
        2: '中',
        3: '小',
        4: '较小'
    }
    const pageData: any = reactive({
      loading: true,
      theme: theme,
      market: market,
      symbol: symbol,
      upReasonPrefix: '异动原因：',
      strengthArr: [
        {
            name: '强弱特征',
            type: null,
            typeName: null,
            reason: null
        },
        {
            name: '市场情绪',
            type: null,
            typeName: null,
            reason: null
        },
        {
            name: '形态位置',
            type: null,
            typeName: null,
            reason: null
        },
        {
            name: '个股体量',
            type: null,
            typeName: null,
            reason: null
        }
      ],
      isToday: false,
      countDays: '',
      countBoard: '',
      upLimitType: '',
      name: '',
      upReason: '',
      exText: '...展开',
      isEx: false,
      dataState: 0,
      LastPrice: '--',
      Updown: '',
      rise: '--',
      PreClosePrice: '',
      upLimitStrength: '',
      upLimitStrengthType: '',
      upLimitStrengthText: '',
      upLimitStrengthTime: '',
      hasYestStrength: false,
      noData: 0, //是否有更新资源返回
      img: '',
      upLimitStrengthTitle: '',
      loadingImg: ''
    })

    if (theme === 'dark') {
        pageData.img = require('@/assets/nodata_dark_v.png')
        pageData.loadingImg = require('@/assets/deepLoading.png')
      } else {
        pageData.img = require('@/assets/nodata_light_v.png')
        pageData.loadingImg = require('@/assets/shallowLoad.png')
    }

    //获取接口数据
    function getUpAnalysis() {
        console.log('打印获取接口数据========')
        upAnalysis.getUpAnalysis({
            tradingDay: newTime,
            market: pageData.market,
            symbol: pageData.symbol,
            token
        }).then(( res:any ) => {
            console.log('打印res数据====',res)
            if(res.data){
                pageData.name = res.data.name
                pageData.dataState = res.data.pxChangeRate > 0 ? 1 : res.data.pxChangeRate < 0 ? -1 : 0
                pageData.strengthArr = [
                    {
                        name: '强弱特征',
                        type: res.data.strength,
                        typeName: type1[res.data.strength],
                        reason: res.data.strengthText
                    },
                    {
                        name: '市场情绪',
                        type: res.data.sentiment,
                        typeName: type1[res.data.sentiment],
                        reason: res.data.sentimentText
                    },
                    {
                        name: '形态位置',
                        type: res.data.morPos,
                        typeName: type1[res.data.morPos],
                        reason: res.data.morPosText
                    },
                    {
                        name: '个股体量',
                        type: res.data.stockWeight,
                        typeName: type2[res.data.stockWeight],
                        reason: res.data.stockWeightText
                    }
                ]
                pageData.upReason = res.data.upReason
                pageData.LastPrice = res.data.lastPx
                pageData.rise = (res.data.pxChangeRate *100).toFixed(2)
                pageData.Updown = res.data.lastPx * (res.data.pxChangeRate).toFixed(2)
                pageData.upLimitType = res.data.upLimitType
                pageData.upLimitStrength = res.data.upLimitStrength
                pageData.upLimitStrengthType = type1[res.data.upLimitStrength]
                pageData.upLimitStrengthText = res.data.upLimitStrengthText
                pageData.upLimitStrengthTime = res.data.upLimitStrengthTime
                pageData.upLimitStrengthTitle = res.data.upLimitStrengthTitle
                pageData.countDays = res.data.countDays
                pageData.countBoard = res.data.countBoard
                pageData.upReasonPrefix = res.data.upReasonPrefix
                pageData.noData = newTime && ( newTime <= res.data.upLimitStrengthTime )  ? 1 : -1
            }else{
                pageData.noData = -1
            }
        })
    }
    onMounted(()=>{
        getUpAnalysis()
        if(isToday(newTime)){
            pageData.isToday = true
            ws.websocket.safeSubscribeDYNA(pageData.symbol,pageData.market)
            ws.websocket.safeSubscribeSTATISTICS(pageData.symbol,pageData.market);
            ws.websocket.on('onDYNA', ( msg: any)  => {
                console.log('打印数据====',msg?.QuoteData?.DynaData[0])
                if(msg?.QuoteData?.DynaData[0]){
                    const data = msg?.QuoteData?.DynaData[0]
                    console.log('内部打印数据===',data)
                    pageData.LastPrice = data?.LastPrice
                    pageData.rise = data?.Updown  * 100
                    pageData.dataState = (pageData.rise > 0) ? 1 : (pageData.rise < 0) ? -1 : 0
                }
            })
            ws.websocket.on("onSTATISTICS", (msg :any) => {
            if (msg.Inst === pageData.symbol && pageData.market.toUpperCase() === msg.Market) {
                const data = msg?.QuoteData?.StatisticsData[0]
                pageData.PreClosePrice = data?.PreClosePrice
                
            }
            });
        }else{
            pageData.isToday = false
        }
        nextTick(()=>{
            pageData.loading = false
        })
    })
    function isToday(timestamp : any) {
        // 获取当前日期的开始时间（0点）
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // 获取当前日期的结束时间（23:59:59）
        const endOfDay = new Date(today);
        endOfDay.setHours(23, 59, 59, 999);

        // 将时间戳转换为 Date 对象
        const date = new Date(timestamp);

        // 判断时间戳是否在今天的范围内
        return date >= today && date <= endOfDay;
    }

    function boardText( countDays:any, countBoard:any) {
        if( countDays == countBoard ){
            if(countBoard == 1){
                return '首板'
            }else if(countBoard > 1){
                return `${countBoard}连板`
            }else{
                return ''
            }
        }else{
            if( countDays && countBoard ){
                return `${countDays}天${countBoard}板`
            }else{
                return ''
            }
        }
    }
    function timestampToDate(timestamp: any) {
        if(timestamp){
            const curYear = new Date().getFullYear();
            const date = new Date(timestamp); // 将时间戳转换为 Date 对象
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，+1得到正确的月份
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return curYear == year ? `${month}-${day} ${hours}:${minutes}` : `${year}-${month}-${day} ${hours}:${minutes}`;
        }else{
            return ''
        }
    }

    function exReason() {
        console.log('点击=====')
        pageData.isEx = !pageData.isEx
        pageData.exText = pageData.exText == '...展开' ? '收起' : '...展开'
    }
    function dbClickRow(row:any) {
        console.log('双击=====',row)
        stock.gotoDetail(row)
    }


    return {
      ...toRefs(pageData),
      exReason,
      timestampToDate,
      boardText,
      dbClickRow
    }
  }
})
